import * as React from 'react';

const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7085 6.70711C19.0991 6.31658 19.0991 5.68342 18.7085 5.29289C18.318 4.90237 17.6848 4.90237 17.2943 5.29289L12.0006 10.5866L6.70686 5.29289C6.31634 4.90237 5.68317 4.90237 5.29265 5.29289C4.90212 5.68342 4.90212 6.31658 5.29265 6.70711L10.5864 12.0008L5.29265 17.2946C4.90212 17.6851 4.90212 18.3182 5.29265 18.7088C5.68317 19.0993 6.31634 19.0993 6.70686 18.7088L12.0006 13.415L17.2943 18.7088C17.6848 19.0993 18.318 19.0993 18.7085 18.7088C19.0991 18.3182 19.0991 17.6851 18.7085 17.2946L13.4148 12.0008L18.7085 6.70711Z"
      fill="white"
    />
  </svg>
);

export default CloseIcon;
